<template>
  <div class="CadastroUsuarios">

    <el-dialog 
      :title="usuario.id ? 'Editar Usuário' : 'Novo Usuário'" 
      :visible="formCadastroUsuario" 
      :show-close="false" 
      fullscreen
    >
      <el-form
        :model="usuario"
        :rules="rules"
        ref="usuario"
        :label-position="labelPosition"
        class="demo-usuario"
      >
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="Código SGE" prop="sge_cod_usuario">
              <el-input v-model="usuario.sge_cod_usuario" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="Nome" prop="nome">
              <el-input v-model="usuario.nome"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="Telefone" prop="telefone">
              <el-input v-model="usuario.telefone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item label="Email" prop="email">
              <el-input v-model="usuario.email" :disabled="!!usuario.id"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10" v-if="!usuario.id">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="Senha" prop="pass">
              <el-input 
                type="password" 
                v-model="usuario.pass" 
                auto-complete="new-password"
                ></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="Repita a senha" prop="checkPass">
              <el-input
                type="password"
                v-model="usuario.checkPass"
                auto-complete="new-password"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-row style="text-align: left; margin: 0 0 10px 8px;">
            Fabricante
          </el-row>
          <el-col>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20">
                <el-form-item>
                  <el-select 
                    v-model="cod_fabricante" 
                    placeholder="Selecione um fabricante para adicionar" 
                    filterable 
                    style="width: 100%"
                    clearable
                  >
                    <el-option
                      v-for="item in listaFabricantes"
                      :key="item.CODIGO"
                      :label="item.RAZAO_SOCIAL"
                      :value="item.CODIGO"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
                <el-button 
                  type="primary" 
                  @click="incluirFabricante(cod_fabricante)"
                  style="width: 100%; margin-bottom: 22px;" 
                  icon="el-icon-circle-plus"
                  :disabled="!cod_fabricante"
                >
                  Adicionar Fabricante
                </el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <h4 style="text-align: left;">Fabricantes Selecionados</h4>
            <el-form-item>
              <el-table
                :data="listaFabricanteSelecionados"
                width="100%"
                height="174px"
                border
                size="small"
                v-loading="loading"
                :empty-text="'Sem dados'"
                :highlight-current-row="true"
              >
                  <el-table-column prop="acao" label="Ação" width="60" filter-placement="bottom-end">
                    <template slot-scope="scope">
                        <el-button
                          size="mini"
                          type="primary"
                          style="margin:2px 0"
                          @click="excluirFabricante(scope.$index)"
                          icon="el-icon-remove"
                        ></el-button>
                    </template>
                  </el-table-column>
                  <el-table-column prop="fabricante_nome" label="Fabricante" sortable min-width="190"></el-table-column>
                  <el-table-column label="Grupo Usuário" prop="id_grupo" sortable min-width="190">
                   <template slot-scope="scope">
                    <el-select 
                      v-model="scope.row.id_grupo"
                      placeholder="Selecione o grupo do Usuário" 
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="item in listaGrupos"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </template>
                  </el-table-column>
                  <el-table-column label="Nível Usuário" prop="id_nivel" sortable min-width="190">
                   <template slot-scope="scope">
                    <el-select 
                      v-model="scope.row.id_nivel"
                      placeholder="Selecione o nível do Usuário" 
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="item in listaNivelUsuario"
                        :key="item.id"
                        :label="item.nome"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </template>
                  </el-table-column>
                  <el-table-column label="Usuário Superior" prop="id_users_superior" sortable min-width="190">
                   <template slot-scope="scope">
                    <el-select 
                      v-model="scope.row.id_users_superior"
                      placeholder="Selecione o Usuário Superior" 
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="item in usuariosFiltrados(scope.row.id_fabricante)"
                        :key="item.id_users"
                        :label="item.nome"
                        :value="item.id_users"
                      ></el-option>
                    </el-select>
                  </template>
                  </el-table-column>

              </el-table>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="importarPessoasSGE()">Importar Pessoas SGE</el-button>
        <el-button @click="handleFechar()">Cancelar</el-button>
        <el-button type="primary" @click="submitForm('usuario')" :disabled="listaFabricanteSelecionados.length < 1">Salvar</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import FuncoesUteis from "../../plugins/FuncoesUteis";

// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

export default {
    props: {
      formCadastroUsuario: {
        type: Boolean,
        default: false,
      },
    itemEditado: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      labelPosition: "right",
      loading: true,
      listaGrupos: [],
      listaFabricantes: [],
      listaNivelUsuario: [],
      listaUsuarioSuperior: [],
      listaFabricanteSelecionados: [],
      cod_fabricante: null,
      permisao: {},
      usuario: {
        id: null,
        nome: "",
        email: "",
        pass: "",
        checkPass: "",
      },
      rules: {
        nome: [
          {
            required: true,
            message: "Por Favor, informe o nome do usuário",
            trigger: "blur",
          },
          {
            min: 3,
            message: "O nome deve ter pelo menos 3 caracteres",
            trigger: "blur",
          },
        ],
        email: [
          { required: true, message: "Informe o e-mail.", trigger: "blur" },
          {
            type: "email",
            message: "Informe um e-mail válido.",
            trigger: ["blur", "change"],
          },
        ],
        pass: [
          { required: true, message: "Informe a senha.", trigger: "blur", validator: (rule, value, callback) => {
            if (!this.usuario.id && !value) callback(new Error("Informe a senha."));
            else callback();
          }},
          { min: 6, message: "A senha deve ter pelo menos 6 caracteres.", trigger: "blur", validator: (rule, value, callback) => {
            if (!this.usuario.id && value && value.length < 6) callback(new Error("A senha deve ter pelo menos 6 caracteres."));
            else callback();
          }},
        ],        
        checkPass: [
          { required: true, message: "Repita a senha.", trigger: "blur", validator: (rule, value, callback) => {
            if (!this.usuario.id && !value) callback(new Error("Repita a senha."));
            else callback();
          }},
          {
            validator: (rule, value, callback) => {
              if (!this.usuario.id && value !== this.usuario.pass) {
                callback(new Error("As senhas devem ser iguais"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],        
      },
    };
  },
  watch: {
    formCadastroUsuario(newVal) {
      if (newVal) {
        this.initializeForm();
      }
    },
    itemEditado: {
      handler(newVal) {
        if (newVal && newVal.id) {
          this.getUsuario(newVal.id);
        } else {
          this.resetForm();
        }
      },
      deep: true,
    },
  },
  async mounted() {
    this.permissao = FuncoesUteis.isPermissao();
    if (!this.permissao.editar_user) {
      this.$message.error("Você não tem permissão para acessar esta página.");
      this.$router.push("/");
      return;
    }
    await Promise.all([
      this.getGrupos(),
      this.getNivelUsuario(),
      this.getFabricantes(),
      this.getUsuarioSuperior()
    ]);
  },
  methods: {
    initializeForm() {
      if (this.itemEditado && this.itemEditado.id) {
        this.getUsuario(this.itemEditado.id);
      } else {
        this.resetForm();
      }
    },
    handleFechar() {
      this.$confirm("Tem certeza que deseja sair?", "Aviso", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning",
      })
        .then(() => {
          this.$emit("fechar-janela");
          this.resetForm();
        })
        .catch(() => {});
    },
    resetForm() {
      this.usuario = {
        id: null,
        nome: "",
        email: "",
        pass: "",
        checkPass: "",
      };
      this.cod_fabricante = null;
      this.listaFabricanteSelecionados = [];
      this.$refs.usuario?.resetFields();
      this.getFabricantes();
    },    
    getUsuarioSuperior() {
      this.loading = true;
      axios
        .get(url + "/usuarios_superior", {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        })
        .then((response) => {
          if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.listaUsuarioSuperior = response.data;
          }
        })
        .catch((err) => {
          this.$notify.error({ title: "Erro", message: "Erro ao buscar usuários superiores: " + err });        
        })
        .finally(() => {
          this.loading = false;
        });
    },
    usuariosFiltrados(fabricanteId) {
      let listaUsuariosFiltrados = this.listaUsuarioSuperior.filter((usuario) => {
        const isRelatedToFabricante = usuario.id_fabricante == fabricanteId;
        const isCurrentUser = this.usuario.id != null && usuario.id_users == this.usuario.id;
        return isRelatedToFabricante && !isCurrentUser;
      });
      listaUsuariosFiltrados.push({
        id_users: 0,
        nome: "Sem usuário superior",
      });
      return listaUsuariosFiltrados.sort((a, b) => {
        // Garante que "Sem usuário superior" fique no topo se você quiser
        if (a.id_users === 0) return -1;
        if (b.id_users === 0) return 1;
        // Converte para lowercase para uma ordenação sem distinção de maiúsculas/minúsculas
        const nomeA = a.nome ? a.nome.toLowerCase() : '';
        const nomeB = b.nome ? b.nome.toLowerCase() : '';
        if (nomeA < nomeB) return -1;
        if (nomeA > nomeB) return 1;
        return 0;
      });
    },
    getGrupos() {
      this.loading = true;
      axios
        .get(url + "/grupos_list", {
          headers: {Authorization: "Bearer " + this.$store.state.token},
        })
        .then((response) => {
          if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.listaGrupos = response.data;
          }
        })
        .catch((err) => {
          this.$notify.error({ title: "Erro", message: "Erro ao buscar grupos: " + err });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getNivelUsuario() {
      this.loading = true;
      axios
        .get(url + "/nivel_usuario", {
          headers: {Authorization: "Bearer " + this.$store.state.token},
        })
        .then((response) => {
          if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.listaNivelUsuario = response.data;
          }
        })
        .catch((err) => {
          this.$notify.error({ title: "Erro", message: "Erro ao buscar níveis de usuário: " + err });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getFabricantes() {
      this.loading = true;
      axios
        .get(url + "/clientes", {
          headers: {Authorization: "Bearer " + this.$store.state.token},
        })
        .then((response) => {
          if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.listaFabricantes = response.data;
            // console.log("Fabricantes:", this.listaFabricantes);
          }
        })
        .catch((err) => {
          this.$notify.error({ title: "Erro", message: "Erro ao buscar fabricantes: " + err });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getUsuario(id) {
      this.loading = true;
      axios
        .get(url + "/usuario/"+id, {
          headers: {Authorization: "Bearer " + this.$store.state.token},
        })
        .then((response) => {
          if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.usuario = { ...response.data.usuario, pass: "", checkPass: "" };
            this.listaFabricanteSelecionados = response.data.fabricanteSelecionados || [];
            // console.log("#AUW Usuario editado:", this.usuario);
            // console.log("#AKD Fabricantes selecionados:", this.listaFabricanteSelecionados);
            // Remover fabricantes já selecionados da lista de disponíveis
            this.listaFabricanteSelecionados.forEach(fabricanteSelecionado => {
              //this.listaFabricantes = this.listaFabricantes.filter(fabricante => fabricante.CODIGO != String(fabricanteSelecionado.id_fabricante));
              this.listaFabricantes = this.listaFabricantes.filter(fabricante => fabricante.CODIGO != fabricanteSelecionado.id_fabricante);
            });
            this.formCadastroUsuario = true;
          }
        })
        .catch((err) => {
          this.$notify.error({ title: "Erro", message: "Erro ao buscar usuário: " + err });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    incluirFabricante(cod_fabricante){
      if (!cod_fabricante) return;
      const fabricante = this.listaFabricantes.find((fabricante) => fabricante.CODIGO === cod_fabricante);
      if (fabricante) {
        this.listaFabricanteSelecionados.push({
          id: null,
          id_fabricante: cod_fabricante,
          fabricante_nome: fabricante.RAZAO_SOCIAL,
          id_users_superior: null,
          id_grupo: null,
          id_nivel: null,
        });
        this.listaFabricantes = this.listaFabricantes.filter(fabricante => fabricante.CODIGO != cod_fabricante);
        this.cod_fabricante = null; 
      } else {
        this.$notify.error({ title: "Erro", message: "Fabricante não encontrado!" });
      }
    },
    async importarPessoasSGE() {
      try {
        this.loading = true;
        const response = await axios.get(
          url + '/importar-pessoas-sge',
          {
            headers: { Authorization: "Bearer " + this.$store.state.token },
          }
        );
        if (response.data.status === "Token is Expired") {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
          return;
        }
        this.$message.success('Importação gerada com sucesso!');
      } catch (error) {
        this.$message.error('Erro ao importar: ' + (error.response?.data?.message || error.message));
      } finally {
        this.loading = false;
      }
    },
    excluirFabricante(index){
      const fabricante = this.listaFabricanteSelecionados[index];
      this.listaFabricantes.push({
        CODIGO: fabricante.id_fabricante,
        RAZAO_SOCIAL: fabricante.fabricante_nome,
      });
      this.listaFabricanteSelecionados.splice(index, 1);
    },
    submitForm(formName) {
      if (this.listaFabricanteSelecionados.length < 1) {
        this.$notify.error({ title: "Erro", message: "Selecione pelo menos um fabricante associado ao usuário!" });
        return;
      }
      for (const fabricante of this.listaFabricanteSelecionados) {
        if (!fabricante.id_grupo) {
          this.$notify.error({ title: "Erro", message: `Selecione o Grupo do usuário para o fabricante: ${fabricante.fabricante_nome || "Não Informado"}!` });
          return;
        }
        if (!fabricante.id_nivel) {
          this.$notify.error({ title: "Erro", message: `Selecione o Nível do usuário para o fabricante: ${fabricante.fabricante_nome || "Não Informado"}!` });
          return;
        }
        if (fabricante.id_users_superior == null) {
          this.$notify.error({ title: "Erro", message: `Selecione o Usuário Superior para o fabricante: ${fabricante.fabricante_nome || "Não Informado"}!` });
          return;
        }
      }
      this.$refs[formName].validate((valid) => {
      if (!valid) {
          this.$message.info("Informe os dados corretamente!");
          return;
        }
        const dados = {
          id: this.usuario.id,
          nome: this.usuario.nome,
          email: this.usuario.email,
          telefone: this.usuario.telefone || undefined,
          password: this.usuario.pass || undefined,
          password_confirmation: this.usuario.checkPass || undefined,
          fabricantes: this.listaFabricanteSelecionados,
        };

        // console.log("#ABG Dados para envio:", dados);

        const request = this.usuario.id
          ? axios.put(url + "/register/" + this.usuario.id, dados, {
              headers: { Authorization: "Bearer " + this.$store.state.token },
            })
          : axios.post(url + "/register/", dados, {
              headers: { Authorization: "Bearer " + this.$store.state.token },
            });        
            
        request
          .then(() => {
            this.$notify.success({
              title: "Sucesso",
              message: this.usuario.id ? "Usuário atualizado com sucesso!" : "Usuário cadastrado com sucesso!",
            });
            this.$emit("salvar-item");
            this.resetForm();            
          })
          .catch((err) => {
            this.$notify.error({ title: "Erro", message: `Erro ao ${this.usuario.id ? "atualizar" : "cadastrar"} os dados: ${err}` });
          })
          .finally(() => {
            this.getUsuarioSuperior();
          });
      });
    },
  },
};
</script>
